module.exports = __webpack_public_path__ + "img/10-4.373160fa.jpg";